import { useState } from "react";

import { WorkerAvatarStyles } from "./workerAvatar.styles";

const getInitials = (firstName = "", lastName = "") => {
  const first = firstName.trim().charAt(0);
  const last = lastName.trim().charAt(0);
  return `${first}${last}`.toUpperCase() || "?";
};

const WorkerAvatar = ({
  firstName,
  lastName,
  profileImage,
  size = 28,
  title
}) => {
  const [imageFailed, setImageFailed] = useState(false);
  const hasImage = !!profileImage?.url && !imageFailed;
  const fullName = `${firstName || ""} ${lastName || ""}`.trim();

  return (
    <WorkerAvatarStyles $size={size} title={title ?? fullName}>
      {hasImage ? (
        <img
          src={profileImage.url}
          alt={fullName || "worker"}
          className="profileImage"
          onError={() => setImageFailed(true)}
        />
      ) : (
        <span className="initials">{getInitials(firstName, lastName)}</span>
      )}
    </WorkerAvatarStyles>
  );
};

export default WorkerAvatar;
